The date & time that the subscription replay was last updated.

Subscription replays are updated whenever the replay makes forward progress.
